'use client';
import { useEffect } from 'react';

import { openFinanceLeadModalAtom } from '@core/Atoms/FinanceModal/FinanceModal.atom';
import { activeLeadFormAtom } from '@core/Atoms/Leads/ActiveLeadForm.atom';
import { localeAtom } from '@core/Atoms/Locale/Locale.atom';

import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { flagsAtom } from '@growthBookExperimentation/Atoms/Flags.atom';
import { openModalAtom } from '@modal/Atoms/Modal.atom';

import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import { leadFormIdAtom } from 'Atoms/App/Pdp/LeadFormId.atom';
import useLeadFormHeaderTextExperiment from 'Components/LeadForms/Hooks/useLeadFormHeaderTextExperiment';
import { LeadForm } from 'Components/LeadForms/LeadForm/LeadForm';

import styles from './FinanceDealer.module.css';

export type OpenFinanceLeadModalProps = {
  strings: Record<string, any>;
};

const OpenFinanceLeadModal = ({
  strings: { pdpStrings: messages, leadFormMessages },
}: OpenFinanceLeadModalProps) => {
  const vehicle = useAtomValue(currentVehicleAtom);
  const [shouldOpenFinanceLeadModal, setShouldOpenFinanceLeadModal] =
    useAtom(openFinanceLeadModalAtom);
  const [locale] = useAtom(localeAtom);
  const flags = useAtomValue(flagsAtom);
  const setOpenModal = useSetAtom(openModalAtom);
  const setLeadFormId = useSetAtom(leadFormIdAtom);
  const toggleLeadForm = useSetAtom(activeLeadFormAtom);

  const { header } = useLeadFormHeaderTextExperiment('message-dealer-finance', vehicle, {
    ...leadFormMessages,
    ...messages,
  });

  useEffect(() => {
    if (shouldOpenFinanceLeadModal) {
      if (flags.refactoredLeadForms) {
        toggleLeadForm('message-dealer-finance');
      } else {
        setLeadFormId('message-dealer-finance');
        setOpenModal(<LeadForm strings={{ ...leadFormMessages, ...messages }} locale={locale} />, {
          header,
          modalClassName: styles.modalContainer,
          modalBodyClassName: styles.modalBodyClassName,
        });
        setShouldOpenFinanceLeadModal(false);
      }
    }
  }, [shouldOpenFinanceLeadModal]);

  return null;
};

export default OpenFinanceLeadModal;
